<template>
  <div class='h-dialogContainer h-track-tabPage'>
    <div class='row h-reset-margin'>
      <div class='h-outTabs h-dislogTabs'>
        <ejs-tab ref='tabs' heightAdjustMode='Auto' :selecting='tabSelect'>
          <e-tabitems>
            <e-tabitem v-for='(item, index) in tabItems' :key='index' :header='item.header' :content='item.content'></e-tabitem>
          </e-tabitems>
        </ejs-tab>
      </div>
    </div>
    <div v-for='(item, index) in primaryData' :key='index' :id='item.name' style='display: none;'>
      <div class='h-padding-25'>
        <BaseBusiness :formParam='item' :ref='item.name' :opCode='opCode' ></BaseBusiness>
        <div class='h-clear-rowMg'></div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseBusiness from './BaseBusiness';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'AddTrackTask',
  components: {
    BaseBusiness
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      opCode: 'add',
      primaryData: [],
      tabItems: [],
      currentNeData: {}
    };
  },
  methods: {
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    loadNeForm(currentNe) {
      try {
        // this.$refs.tabs.ej2Instances.refresh();
        this.currentNeData = currentNe;
        this.primaryData = [];
        const tabObj = [];
        let formDatas = JSON.parse(localStorage.getItem('trackForms'));
        if (!formDatas) {
          formDatas = {};
        }
        const formData = formDatas[`${currentNe.displaySoftwareVersion}${currentNe.typeCode}${this.locale}`];
        if (formDatas && formData) {
          Object.entries(formData).forEach((value) => {
            this.primaryData.push(value[1]);
            tabObj.push({ header: { text: value[1].name }, content: `#${value[1].name}` });
          });
          this.tabItems = tabObj;
          // this.$refs.tabs.ej2Instances.items = tabObj;
        } else {
          this.$axios.get(`/lte/ems/track/queryFormConfig?version=${currentNe.displaySoftwareVersion}&neType=${currentNe.typeCode}`).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              const result = response.data.resultVal;
              Object.entries(result).forEach((value) => {
                this.primaryData.push(value[1]);
                tabObj.push({ header: { text: value[1].name }, content: `#${value[1].name}` });
              });
              this.tabItems = tabObj;
              result.forEach(form => {
                if (!formDatas[`${currentNe.displaySoftwareVersion}${currentNe.typeCode}${this.locale}`]) {
                  formDatas[`${currentNe.displaySoftwareVersion}${currentNe.typeCode}${this.locale}`] = {};
                }
                formDatas[`${currentNe.displaySoftwareVersion}${currentNe.typeCode}${this.locale}`][form.typeID] = form;
              });
              localStorage.setItem('trackForms', JSON.stringify(formDatas));
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
        // this.$nextTick(() => {
        //   this.$refs.tabs.ej2Instances.refresh();
        // });
      } catch (e) {
        console.log(e);
      }
    },
    getFormData() {
      const index = this.$refs.tabs.ej2Instances.selectedItem;
      const { name } = this.primaryData[index];
      const validateReturn = this.$refs[name][0].validateResult();
      if (!validateReturn) {
        return false;
      }
      const params = this.$refs[name][0].getDatas();
      if (params) {
        params.neId = this.currentNeData.id;
        params.typeId = this.primaryData[index].typeID;
      }
      return params;
    },
  }
};
</script>
